<template>
  <MainNavbar />
  <MainBanner />
  <FeaturedCourse />
  <FAQ />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainBanner from "../components/HomeThree/MainBanner.vue";
import FAQ from "../components/HomeThree/FAQ.vue";
import FeaturedCourse from "../components/HomeThree/FeaturedCourses.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    MainNavbar,
    MainBanner,
    FAQ,
    MainFooter,
    FeaturedCourse,
  },
});
</script>
